export const hexToRgb = (hex: string | undefined) => {
  if (!hex || !/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return undefined;
  }

  return hex
    .slice(1)
    .match(/../g)
    ?.map((b) => parseInt(b, 16));
};
